export const DocBaseUrl = process.env.REACT_APP_DOC_BASE_URL;
export const DocImgBaseUrl = process.env.REACT_APP_DOC_IMG_BASE_URL;
export const execess_url = process.env.REACT_APP_EXECESS_URL;
export const execess_url_down = process.env.REACT_APP_EXECESS_URL_DOWN;
export const DocGridSocketUrl = process.env.REACT_APP_DOCGRID_SOCKET_URL;


